import { render, staticRenderFns } from "./PortineriaTabelloneCronologiaView.vue?vue&type=template&id=00c68bcc&"
import script from "./PortineriaTabelloneCronologiaView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaTabelloneCronologiaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports